import { Component, HostBinding, inject } from '@angular/core';
import { AuthService, ScreenService, AppInfoService } from './shared/services';
import packageJson from '../../package.json';
import { CheckForUpdateService } from './shared/services/check-update/check-for-update.service';
import { compareVersions } from './utils/version-utils';
import { NotAuthorizedContainerComponent } from './not-authorized-container';
import { FooterComponent } from './shared/components';
import { RouterOutlet } from '@angular/router';
import { SideNavOuterToolbarComponent } from './layouts';
import { TokenExpirationCheckComponent } from './shared/utils/token-expiration-check/token-expiration-check.component';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: true,
  imports: [
    NotAuthorizedContainerComponent,
    FooterComponent,
    RouterOutlet,
    SideNavOuterToolbarComponent,
    TokenExpirationCheckComponent,
  ],
})
export class AppComponent {
  private authService = inject(AuthService);
  private screen = inject(ScreenService);
  appInfo = inject(AppInfoService); //Da mantenere public
  private checkUpdates = inject(CheckForUpdateService);

  @HostBinding('class') get getClass() {
    return Object.keys(this.screen.sizes)
      .filter((cl) => this.screen.sizes[cl])
      .join(' ');
  }

  version: string;

  constructor() {
    this.runVersionsCheck();
  }

  runVersionsCheck() {
    this.version = packageJson.version;
    console.log('running version: ' + this.version);
    this.checkUpdates.getVersionFromServer().subscribe({
      next: (res) => {
        const versionFromServer = res.frontendVersion;
        console.log('version from server: ' + versionFromServer);
        const comparison = compareVersions(versionFromServer, this.version);
        if (comparison > 0) {
          console.info('New version available -> ' + versionFromServer);
          document.location.reload();
        } else if (comparison < 0) {
          console.warn(
            'current version (' +
              this.version +
              ') greather then server version (' +
              versionFromServer +
              ')',
          );
        }
      },
      error: (error) => {
        console.error('Error in check version: ' + error?.message);
      },
    });
  }

  isAutorized() {
    return this.authService.loggedIn;
  }
}

export class AppModule{}
